import { Box, CircularProgress } from "@mui/material";

// Neutral loader shown only briefly while MSAL completes authentication/redirect.
const AppLoader = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress size={32} />
    </Box>
  );
};

export default AppLoader;
